import useMultpleTable from '../../../hooks/useMultipleTable';
import { Table } from '../../Table';
import { MultiTableComponentProps } from '../types';

const columnLables = {
  question_number: {
    name: 'Question Number'
  },
  assumption_description: {
    name: 'Assumption Description'
  }
};

export function Assumptions({
  funds,
  currentDataKey,
  onChangeFund,
  schema,
  isStaticTemplate,
  isMultiFunds,
  onAddColumn,
  onDeleteColumn
}: MultiTableComponentProps) {
  const { rows, columns, onChange } = useMultpleTable({
    data: funds[currentDataKey]?.fund_data?.ASSUMPTIONS,
    onChangeFund,
    schema: schema.ASSUMPTIONS,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.ASSUMPTIONS?.field_names || [],
    columnLables,
    // @ts-ignore
    order: 14,
    isMultiFunds,
    funds,
    tableName: 'ASSUMPTIONS',
    onAddColumn,
    onDeleteColumn,
    hasTableOrderNumber: false
  });

  return (
    <Table
      id="reporttables-assumptions-table"
      // @ts-ignore
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
      handleChanges={onChange}
      columns={columns}
      stickyTopRows={isMultiFunds ? 1 : null}
      rows={rows}
    />
  );
}
